import { render, staticRenderFns } from "./MitigationGroupForm.vue?vue&type=template&id=9480878c&scoped=true&"
import script from "./MitigationGroupForm.vue?vue&type=script&lang=js&"
export * from "./MitigationGroupForm.vue?vue&type=script&lang=js&"
import style0 from "./MitigationGroupForm.vue?vue&type=style&index=0&id=9480878c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9480878c",
  null
  
)

export default component.exports